import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import translations from '../../i18n';
import {storeInstance} from '@aofl/store/dist/legacy';
import {rosterErrors, sdoNs} from '@modules/constants-enumerate';
import {RosterUtils} from '@modules/roster-utils';

/**
 * @summary InvalidColumnCount
 * @extends {mapStatePropertiesMixin(i18nMixin(AoflElement))}
 */
@customElement('invalid-column-count')
class InvalidColumnCount extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of InvalidColumnCount.
   */
  constructor() {
    super();
    this.translations = translations;
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'invalid-column-count';
  @property({type: Boolean})
  show = false;
  @property({type: Array})
  errors = [];
  @property({type: String, mapState: `${sdoNs.SESSION}.group_info.level`, store: storeInstance})
  group_info_level = 0;
  @property({type: Object})
  roster = {};
  @property({type: Boolean})
  useActiveRoster = false;

  async getRosterTemplate() {
    await RosterUtils.getRosterTemplate('aofl');
  }

  mapStateProperties() {
    if (this.useActiveRoster) {
      const state = this.storeInstance.getState();

      this.show = state[sdoNs.USER_JOBS].$rosterInvalidColumnCountError;
      if (this.show) {
        this.errors = state[sdoNs.USER_JOBS].$activeRosterJob.errors;
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.roster?.id) {
      this.useActiveRoster = false;
      this.show = this.hasInvalidColumnCountError();
      if (this.show) {
        this.errors = this.roster.errors;
      }
    }
    else {
      this.useActiveRoster = true;
    }
  }

  hasInvalidColumnCountError() {
    if (Array.isArray(this.roster?.errors) &&
    this.roster.errors.length > 0) {
      return this.roster.errors.some((item) => {
        return item.type === rosterErrors.CSV_INVALID_COLUMN_COUNT;
      });
    }
    return false;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    if (this.show) {
      return super.render({
        default: {template, styles: [styles]}
      });
    }
    return super.render({
      default: {template: () => '', styles: [':host {display: none;}']}
    });
  }
}

export default InvalidColumnCount;
